import { Band, displayFont } from "./band-helpers";
import { stats } from "@/lib/content-blocks-data";
import type { StatsBandBlock } from "@/lib/storefront-types";

/** CMS-driven stats band block */
export function StatsBandSection({ block }: { block: StatsBandBlock }) {
  if (block.statsItems.length === 0) return null;

  return (
    <Band
      className="border-y border-white/8 storefront-surface-dark py-10 sm:py-14"
      aria-label="Key statistics"
    >
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {block.statsItems.map((stat) => (
          <div key={stat.label} className="text-center">
            <p
              className={`${displayFont.className} text-[clamp(2.2rem,4.5vw,3.8rem)] font-bold tabular-nums tracking-tight text-white`}
            >
              {stat.value}
            </p>
            <p className="mt-2 text-sm font-semibold uppercase tracking-[0.2em] text-white/50">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </Band>
  );
}

/** Hardcoded stats band used on the /content-blocks demo page */
export function StatsBand() {
  return (
    <Band
      className="border-y border-white/8 storefront-surface-dark py-10 sm:py-14"
      aria-label="Key statistics"
    >
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <p
              className={`${displayFont.className} text-[clamp(2.2rem,4.5vw,3.8rem)] font-bold tabular-nums tracking-tight text-white`}
            >
              {stat.value}
            </p>
            <p className="mt-2 text-sm font-semibold uppercase tracking-[0.2em] text-white/50">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </Band>
  );
}
